module.exports = "<div flex layout-fill ui-view=\"sharedFilesContent\" class=\"my-files__content\" layout=\"column\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/sharebase-app/components/_sharedFiles/sharedFiles.template.html
// module id = 1249
// module chunks = 0